
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.4 23.2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF"}},[_c('polygon',{attrs:{"points":"5.1,6.7 6.4,7.9 7.2,7.1 6,5.8"}}),_c('rect',{attrs:{"x":"3.6","y":"11.6","width":"1.7","height":"1.1"}}),_c('rect',{attrs:{"x":"10.6","y":"3.5","width":"1.1","height":"1.7"}}),_c('path',{attrs:{"d":"M22.4 7.2c-.6-1.4-1.4-2.7-2.5-3.8-1.1-1.1-2.4-1.9-3.8-2.5-1.4-.6-2.9-.9-4.4-.9-1.5 0-3 .3-4.4.9-1.5.6-2.7 1.4-3.8 2.5C2.4 4.5 1.6 5.8 1 7.2.4 8.6.1 10.1.1 11.6c0 1.5.3 3 .9 4.4.6 1.4 1.4 2.7 2.5 3.8 1.1 1.1 2.4 1.9 3.8 2.5 1.4.6 2.9.9 4.4.9 1.5 0 3-.3 4.4-.9 1.4-.6 2.7-1.4 3.8-2.5 1.1-1.1 1.9-2.4 2.5-3.8.6-1.4.9-2.9.9-4.4 0-1.5-.3-3-.9-4.4zM3 15c-.4-1.1-.7-2.2-.6-3.4 0-1.6.4-3.2 1.3-4.6.8-1.4 2-2.6 3.4-3.4 1.4-.8 3-1.3 4.6-1.3 1.2 0 2.3.2 3.4.6 1.1.4 2 1 2.9 1.8L9.3 9.2l-4.4 8.7C4.1 17 3.5 16.1 3 15zm9.6-2.5L9 14.3l1.8-3.5.9.9.9.8zm7.1 3.8c-.8 1.4-2 2.6-3.4 3.4-1.4.8-3 1.3-4.6 1.2-1.2 0-2.3-.2-3.4-.6-1.1-.4-2-1-2.9-1.8l8.7-4.4 4.4-8.7c.8.8 1.4 1.8 1.8 2.9.4 1.1.7 2.2.6 3.4.1 1.6-.3 3.2-1.2 4.6z"}}),_c('rect',{attrs:{"x":"18.1","y":"10.5","width":"1.7","height":"1.1"}}),_c('polygon',{attrs:{"points":"16.2,16.1 17.4,17.4 18.3,16.5 17,15.3"}}),_c('rect',{attrs:{"x":"11.7","y":"18","width":"1.1","height":"1.7"}})])])
          )
        }
      }
    